document.addEventListener('DOMContentLoaded', function () {
  const isApprovedCustomer = document.documentElement.classList.contains('gt-b2b-approved');

  if (isApprovedCustomer) return;

  const protectedLinks = document.querySelectorAll(
    'a[href="/pages/order-lenses"], a[href="/pages/price-list"]'
  );

  protectedLinks.forEach(function (link) {
    const destination = link.getAttribute('href');

    link.setAttribute(
      'href',
      '/account/login?return_to=' + encodeURIComponent(destination)
    );
  });
});